import { Component, Input } from '@angular/core';
import { TerminalOption } from '@components/system-setting/slot-dialog/constant';
import { TranslateService } from '@ngx-translate/core';
import { TerminalSide, TerminalType } from 'icreate/common/models/slot';

@Component({
    selector: 'app-terminal-button',
    templateUrl: './terminal-button.component.html',
    styleUrls: ['./terminal-button.component.css'],
    standalone: false,
})
export class TerminalButtonComponent {
    @Input() terminalType!: TerminalType;
    @Input() titleKey!: string;
    @Input() terminalCount!: number;
    @Input() disabled = false;
    @Input() option: TerminalOption;

    @Input() onClick!: (option: TerminalOption, direction: TerminalSide) => void;

    TerminalDirection = TerminalSide;

    constructor(private translate: TranslateService) {}
}
